<template>
    <div class="c-address">
        <div class="c-address__fields">
            <div class="c-address__zipcode">
                <input type="text" name='zipcode' data-pattern="zipcode" placeholder="1234 AA" :required="required" v-model="field.zipcode"  @input="updateAddress" />
            </div>
            <div class="c-address__input">
                <input type="number" name='housenumber' placeholder="10" :required="required" v-model="field.housenumber" @input="updateAddress"  />
            </div>
            <div class="c-address__input">
                <input type="text" name='addition' placeholder="A" :required="required" v-model="field.addition" @input="updateAddress" />
            </div>
        </div>
        <div class="c-address__data" v-if="checked && found">
            <strong>Adres</strong><br/>
            {{field.street}} {{field.housenumber}} {{field.addition}}<br/>
            {{field.zipcode}} {{field.city}}<br/>
        </div>

        <div class="c-address__nodata" v-if="checked && !found">
            <div class="c-address__input">
                <input type="text" name='street' placeholder="Straat" :required="required" v-model="field.street" @input="updateAddress" />
            </div>
            <div class="c-address__input c-address__input--last">
                <input type="text" name='city' placeholder="Plaats" :required="required" v-model="field.city" @input="updateAddress"  />
            </div>
        </div>
    </div>
</template>

<script>
import { Nutshell } from '@nutshell/core';

export default {
    props: {
        zipcode: {
            type: String,
            default: ''
        },
        housenumber: {
            default: ''
        },
        addition: {
            type: String,
            default: ''
        },
        street: {
            type: String,
            default: ''
        },
        city: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: false,
            found: false,
            field: {
                zipcode: '',
                housenumber: '',
                addition: '',
                street: '',
                city: ''
            }
        }
    },
    watch: {
        'field.zipcode'() {
            this.lookup();
        },
        zipcode(value) {
            this.field.zipcode = value;
        },
        housenumber(value) {
            this.field.housenumber = value;
        },
        addition(value) {
            this.field.addition = value;
        },
        street(value) {
            this.field.street = value;
        },
        city(value) {
            this.field.city = value;
        }
    },
    methods: {
        updateAddress() {
            this.$emit('input', {
                zipcode: this.field.zipcode,
                housenumber: this.field.housenumber,
                addition: this.field.addition,
                street: this.field.street,
                city: this.field.city
            });
        },

        validZipcode() {
            let regex = Nutshell.options.Validator.custom.patterns.zipcode;
            return regex.test(this.field.zipcode);
        },

        lookup() {

            if ( this.validZipcode() ) {

                this.$xhr.get('/api/address/', {
                    zipcode: this.field.zipcode
                }).then( ( {result}) => {
                    this.checked = true;
                    this.found = true;

                    this.field.street = result.street;
                    this.field.city = result.city;

                    this.updateAddress();
                }).catch( () => {
                    this.checked = true;
                    this.found = false;
                });
            }
            else {
                this.checked = false;
                this.found = false;
            }
        }
    },
    mounted() {
        this.field.zipcode = this.zipcode;
        this.field.housenumber = this.housenumber;
        this.field.addition = this.addition;
        this.field.street = this.street;
        this.field.city = this.city;
    }
}
</script>
